<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr-other" style="padding-right: 5px"></i>
        单位信息
      </div>
    </div>
    <ul class="tab-wrap">
      <li :class="`tab-btn ${nowIndex == index && 'active'}`" @click="changeTab(index)" v-for="(tab, index) in tabList">{{ tab.title }}</li>
    </ul>
    <el-form ref="form" :model="form" label-width="110px" :rules="rules" class="mt20" v-show="nowIndex == 0">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-form-item label="单位编号" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_number">
            <el-input v-model="form.base.c_number"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="单位类型" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_type">
            <v-select :value.sync="form.base.c_type" :id="1"></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="上级单位" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_superior">
            <el-select v-model="form.base.c_superior">
              <el-option value="0" label="请选择上级单位"></el-option>
              <el-option value="2" label="联网单位"></el-option>
              <el-option value="3" label="消防监管单位"></el-option>
              <el-option value="4" label="维保单位"></el-option>
              <el-option value="5" label="其他"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="单位名称" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_name">
            <el-input v-model="form.base.c_name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联系电话" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_phone">
            <el-input v-model="form.base.c_phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="入网日期" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_in_net">
            <el-date-picker type="date" placeholder="选择日期" v-model="form.base.c_in_net" value-format="yyyy-MM-dd"></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="联网状态" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_net_status">
            <el-radio-group v-model="form.base.c_net_status">
              <el-radio label="1">已联网</el-radio>
              <el-radio label="0">未联网</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安装信息表" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_setup_table">
            <el-radio-group v-model="form.base.c_setup_table">
              <el-radio label="1">有</el-radio>
              <el-radio label="0">无</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="省" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_province">
            <el-select v-model="form.base.c_province" placeholder="请选择省份" @change="proChanege">
              <el-option :value="item.area_code + ''" :label="item.area_name" v-for="item in allAreaList"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="市" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_city">
            <el-select v-model="form.base.c_city" placeholder="请选择市" @change="cityChanege">
              <el-option :value="item.area_code + ''" :label="item.area_name" v-for="item in cityList"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="区" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_area">
            <el-select v-model="form.base.c_area" placeholder="请选择区">
              <el-option :value="item.area_code + ''" :label="item.area_name" v-for="item in areaList"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="详细地址" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_address">
            <el-input v-model="form.base.c_address"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="级别" prop="base.c_level">
            <!-- <v-select :value.sync="form.base.c_level" :id="6"></v-select> -->
            <el-input v-model="form.base.c_level"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="安全监管级别" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_safe_level">
            <v-select :value.sync="form.base.c_safe_level" :id="38"></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="所属行业" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_belong_profession">
            <v-select :value.sync="form.base.c_belong_profession" :id="66"></v-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="类型" prop="base.c_profession_type">
            <!-- <v-select :value.sync="form.base.c_profession_type" :id="84"></v-select> -->
            <el-input v-model="form.base.c_profession_type"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="邮箱" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_orgin_num">
            <el-input v-model="form.base.c_orgin_num"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="责任人" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_responsible">
            <el-input v-model="form.base.c_responsible"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="管理人" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_manager">
            <el-input v-model="form.base.c_manager"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="部门负责人" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_department_responsible">
            <el-input v-model="form.base.c_department_responsible"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="职工数" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_woker">
            <el-input v-model="form.base.c_woker"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="占地面积" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_land_area">
            <el-input v-model="form.base.c_land_area"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="总面积" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_total_area">
            <el-input v-model="form.base.c_total_area"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="消防信息" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_firefighting_messsage">
            <el-input v-model="form.base.c_firefighting_messsage"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="单位简介" prop="base.c_bim_href">
            <el-input type="textarea" v-model="form.base.c_bim_href"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="视频相关字段" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_video_filter">
            <el-input v-model="form.base.c_video_filter"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="视频IP/域名" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_video_ip">
            <el-input v-model="form.base.c_video_ip"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="端口/空" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_port">
            <el-input v-model="form.base.c_port"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="插件类型" :rules="{ message: '请填写/选择', trigger: 'blur', required: true }" prop="base.c_plugin_type">
            <v-select :value.sync="form.base.c_plugin_type" :id="86"></v-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-for="(item, index1) in tabList" v-show="nowIndex == index1" v-if="index1 !== 0">
      <div class="btn-box">
        <div class="l-btn" @click="addList(index1)"><i class="icon-tr-newly-added"></i>新增</div>
      </div>
      <table class="common-table mt20">
        <thead>
          <tr>
            <th v-for="data in item.data">
              {{ data.text }}
            </th>
            <th>
              操作
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in form[tabList[index1].form]">
            <td class="common-add" v-for="(input, key, index2) in tabList[index1].data">
              <el-input placeholder="请输入" v-model="form[tabList[index1].form][index][input.form_name]" v-if="input.type == 'text'"></el-input>
              <div v-if="input.type == 'select'">
                <v-select :value.sync="form[tabList[index1].form][index][input.form_name]" :id="input.op_id || input.option"></v-select>
              </div>
              <el-date-picker
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择日期"
                v-model="form[tabList[index1].form][index][input.form_name]"
                v-if="input.type == 'date'"
              ></el-date-picker>
            </td>
            <td class="td-btn">
              <a class="clear-data" @click="del(index)">
                <i class="icon-tr-delete"></i>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="btn-box">
      <div class="l-btn" @click="onSubmit">保存</div>
      <div class="l-btn ml20" @click="$router.back()">返回</div>
    </div>
  </div>
</template>

<script>
import { editCompany, getCompany } from "../../api/company";
import { getArea } from "../../api/common";
import { sigtype } from "./options";
import getLoation from "./getLoation";
export default {
  data() {
    return {
      id: this.$route.query.id,
      form: {
        base: {
          c_number: "",
          c_type: "",
          c_superior: "",
          c_name: "",
          c_phone: "",
          c_in_net: "",
          c_net_status: "",
          c_province: "",
          c_city: "",
          c_area: "",
          c_address: "",
          c_setup_table: "",
          c_safe_level: "",
          c_belong_profession: "",
          c_orgin_num: "",
          c_responsible: "",
          c_manager: "",
          c_department_responsible: "",
          c_woker: "",
          c_land_area: "",
          c_total_area: "",
          c_firefighting_messsage: "",
          c_bim_href: "",
          c_video_filter: "",
          c_video_ip: "",
          c_port: "",
          c_plugin_type: "",
        },
        get_build: [],
        get_control: [],
        get_server: [],
        get_facility: [],
        get_transmission: [],
        get_interface: [],
        get_message: [],
        get_onduty: [],
      },
      rules: {},
      nowIndex: 0,
      allAreaList: [],
      cityList: [],
      areaList: [],
      tabList: [
        { title: "基本信息", form: "base" },
        {
          title: "建筑信息",
          form: "get_build",
          data: [
            { form_name: "cb_use_type", type: "text", text: "建筑使用性质" },
            { form_name: "cb_height", type: "text", text: "高度" },
            { form_name: "cb_on", type: "text", text: "地上层数" },
            { form_name: "cb_under", type: "text", text: "地下层数" },
            { form_name: "cb_area", type: "text", text: "面积" },
            { form_name: "cb_name", type: "text", text: "建筑名称" },
          ],
        },
        {
          title: "消防设施",
          form: "get_facility",
          data: [
            { form_name: "cf_name", type: "text", text: "消防设施名称" },
            { form_name: "cf_brand", type: "text", text: "消防品牌" },
            { form_name: "cf_norm", type: "text", text: "规格型号" },
            { form_name: "cf_node", type: "text", text: "节点数" },
            { form_name: "cf_quantity", type: "text", text: "数量" },
          ],
        },
        {
          title: "传输装备",
          form: "get_transmission",
          data: [
            { form_name: "ct_transmission_num", type: "text", text: "设备编号" },
            { form_name: "ct_transmission_type", type: "select", text: "设备类型", op_id: 28 },
            { form_name: "ct_transmission_model", type: "text", text: "设备型号" },
            { form_name: "ct_child_number", type: "text", text: "子号" },
            { form_name: "ct_part_num", type: "text", text: "部位号" },
            { form_name: "ct_transmission_name", type: "text", text: "设备名称" },
            { form_name: "ct_heart_beat", type: "text", text: "心跳时间(s)" },
            { form_name: "ct_local", type: "text", text: "安装位置" },
            { form_name: "ct_setup_data", type: "date", text: "安装日期" },
            { form_name: "ct_open_date", type: "date", text: "开通日期" },
          ],
        },
        {
          title: "接口资料",
          form: "get_interface",
          data: [
            { form_name: "ci_num", type: "text", text: "12位编号" },
            { form_name: "ci_snum", type: "text", text: "子号" },
            { form_name: "ci_message_type", type: "text", text: "信号类型", op_id: 171 },
            { form_name: "ci_sys_type", type: "select", text: "系统类型", op_id: 16 },
            { form_name: "ci_port", type: "text", text: "端口号" },
            { form_name: "ci_device_name", type: "text", text: "设备名称" },
            { form_name: "ci_simulation_sys", type: "text", text: "模拟系数" },
            { form_name: "ci_cap", type: "text", text: "上限" },
            { form_name: "ci_lower", type: "text", text: "下限" },
            { form_name: "ci_unit", type: "text", text: "单位" },
          ],
        },
        {
          title: "消防服务",
          form: "get_server",
          data: [
            { form_name: "cd_unit_name", type: "text", text: "单位名称" },
            { form_name: "cd_type", type: "select", text: "单位类型", op_id: 1 },
            { form_name: "cd_user", type: "text", text: "联系人" },
            { form_name: "cd_phone", type: "text", text: "联系人电话" },
          ],
        },
        {
          title: "消控室",
          form: "get_control",
          data: [
            { form_name: "cc_num", type: "text", text: "消控室编号" },
            { form_name: "cc_name", type: "text", text: "消控室名称" },
            { form_name: "cc_build", type: "select", text: "所属建筑", op_id: 100 },
            { form_name: "cc_address", type: "text", text: "地址" },
            { form_name: "cc_user", type: "text", text: "责任人" },
            { form_name: "cc_device", type: "text", text: "设备" },
          ],
        },
        {
          title: "值班人员",
          form: "get_onduty",
          data: [
            { form_name: "co_name", type: "text", text: "值班人员" },
            { form_name: "co_phone", type: "text", text: "值班人电话" },
            { form_name: "co_duty", type: "text", text: "值班人职务" },
          ],
        },
        {
          title: "短信通知",
          form: "get_message",
          data: [
            { form_name: "cm_name", type: "text", text: "姓名" },
            { form_name: "cm_post", type: "text", text: "岗位" },
            { form_name: "cm_phone", type: "text", text: "电话" },
            {
              form_name: "cm_push",
              type: "select",
              text: "是否推送",
              option: [
                { mc_id: 1, mc_name: "是" },
                { mc_id: 0, mc_name: "否" },
              ],
            },
            { form_name: "cm_push_type", type: "select", text: "推送类型", op_id: 104 },
          ],
        },
      ],
    };
  },
  created() {
    this.getCompany();
    this.tabList.forEach((it, index) => {
      let obj = {};
      if (it.data && !this.form[it.form].length) {
        it.data.forEach((li) => {
          obj[li.form_name] = "";
        });
        this.form[it.form].push(obj);
      }
    });
    getArea().then((res) => {
      this.allAreaList = res.data;
      this.proChanege(1);
      this.cityChanege(1);
    });
  },
  mounted() {},
  methods: {
    getCompany() {
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      getCompany(this.id)
        .then((res) => {
          let data = res.data;
          let base = {};
          for (let key in data) {
            if (typeof data[key] === "object" && data[key]) {
              this.form[key] = data[key];
            } else {
              base[key] = data[key];
            }
          }
          this.form.base = base;

          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },

    proChanege(flag) {
      this.cityList = [];
      this.areaList = [];
      flag !== 1 && (this.form.base.c_city = "");
      flag !== 1 && (this.form.base.c_area = "");
      this.allAreaList.forEach((it) => {
        if (it.area_code == this.form.base.c_province) {
          this.cityList = it.city;
        }
      });
    },
    cityChanege(flag) {
      this.areaList = [];
      !flag && (this.form.base.c_area = "");
      this.cityList.forEach((it) => {
        if (it.area_code == this.form.base.c_city) {
          this.areaList = it.get_area;
        }
      });
    },
    addList(index) {
      let obj = {};
      this.tabList[this.nowIndex].data.forEach((it) => {
        obj[it.form_name] = "";
      });
      this.form[this.tabList[this.nowIndex].form].push(obj);
    },
    del(index) {
      this.form[this.tabList[this.nowIndex].form].splice(index, 1);
    },
    changeTab(index) {
      this.nowIndex = index;
    },
    onSubmit() {
      this.save();
      this.$refs.form.validate((valid) => {
        if (valid) {
          //this.save()
        } else {
          this.nowIndex = 0;
          return false;
        }
      });
    },
    save() {
      this.form.base.id = +this.$route.query.id;
      let logading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      editCompany(this.form)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          logading.close();
          this.$router.back();
        })
        .catch((res) => {
          logading.close();
        });
    },
  },
};
</script>

<style scoped></style>
